"use strict";

const RoutineInspectionRouteFactory = require("./routineInspectionRouteFactory");

const LiftStationRoutes = function () {
  const inspectionRoute = RoutineInspectionRouteFactory.createRoute({
    resourceKey: "liftStationRoutineMaintenance",
    assetType: "liftStation",
  });

  return { inspectionRoute };
};

module.exports = LiftStationRoutes();
